import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useSize = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();

  const dealSizeSchema = useMemo(() => createRangeSchema({ bounds: filters?.dealSize }), [filters?.dealSize]);
  const trancheSizeSchema = useMemo(() => createRangeSchema({ bounds: filters?.trancheSize }), [filters?.trancheSize]);

  const dealSize = useRangeFilter({ fromKey: 'includedDealSizeFrom', toKey: 'includedDealSizeTo', schema: dealSizeSchema });
  const trancheSize = useRangeFilter({ fromKey: 'includedTrancheSizeFrom', toKey: 'includedTrancheSizeTo', schema: trancheSizeSchema });

  return { dealSize, trancheSize };
};

export default useSize;
